export default "__VITE_ASSET__6f958b03__"